import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { queryClientConfig } from '@const/queryClientConfig';

// React Query client for data-fetching through hook usage
const queryClient = new QueryClient(queryClientConfig);

export const ReactQueryProvider = ({ children }: { children: React.ReactNode }) => {
	return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
